import React from 'react';

interface ErrorMessageProps {
  error?: string[] | string | undefined | void;
}

const ErrorMessage = ({ error }: ErrorMessageProps) => {
  if (!error || !error.length) return null;

  return <div className="alert alert-danger is-sm">{Array.isArray(error) ? error[0] : error}</div>;
};

export default ErrorMessage;
